import {
  TimelinePanel,
  TimelinePanelSubComponents,
  useTimelinePanelStore,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationHistoryHeader.module.scss";

const cx = classNames.bind(styles);

/**
 * Collapsible header for the investigation history TimelinePanel drawer.
 */
const InvestigationHistoryHeader = () => {
  const { isOpen } = useTimelinePanelStore();

  return (
    <TimelinePanel.Header
      className={cx("header", { collapsed: !isOpen })}
      titleSectionClassName={cx("title-section", { collapsed: !isOpen })}
      titleClassName={cx("title-heading", { collapsed: !isOpen })}
      headerActionClassName={cx("collapse-button", { collapsed: !isOpen })}
      title={
        <span className={cx("title", { collapsed: !isOpen })}>
          Investigations
        </span>
      }
    />
  );
};

InvestigationHistoryHeader.displayName = TimelinePanelSubComponents.HEADER;

export { InvestigationHistoryHeader };
